<!--人员管理 角色管理-->
<template>
  <div>
    <el-row>
      <el-form size="medium" :inline="true" class="demo-form-inline" style="padding-top:0;margin-top:20px" :model="searchForm" ref="searchForm"
        label-suffix="：">
        <el-form-item label="姓名">
          <el-input placeholder="姓名" v-model="searchForm.NAME" clearable @keyup.enter.native="handleSearch()">
          </el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input placeholder="手机号" v-model="searchForm.MOBILE" clearable @keyup.enter.native="handleSearch()">
          </el-input>
        </el-form-item>
        <el-form-item label="部门">
          <el-input placeholder="部门" v-model="searchForm.DEPARTMENT_NAME" clearable @keyup.enter.native="handleSearch()"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.STATUS" placeholder="请选择">
            <el-option v-for="item in STATUS_LIST" :key="item.status" :label="item.name" :value="item.status">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" id="search" @click="handleSearch()">筛选</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="4">
        <el-button size="medium" @click="addVisible = true" style="margin-bottom:10px">新增</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column prop="NAME" label="人员"></el-table-column>
          <el-table-column prop="MOBILE" label="手机号"></el-table-column>
          <el-table-column prop="DEPARTMENT_NAME" label="部门"></el-table-column>
          <el-table-column prop="STATUS" label="状态">
            <template slot-scope="scope">
              <el-tag :type="scope.row.STATUS === 0 ? 'warning' : ''">{{ setStatus(scope.row.STATUS) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="350px" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="detail(scope.row)">角色管理</el-button>
              <el-button type="text" size="small" icon="el-icon-edit" @click="editPerson(scope.row)">修改</el-button>
              <el-button type="text" size="small" icon="el-icon-edit" @click="initPWD(scope.row)">重置密码</el-button>
              <el-button type="text" size="small" icon="el-icon-close" @click="stopFun(scope.row)" v-if="scope.row.STATUS === 1"
                style="color: rgb(245, 108, 108)">
                禁用
              </el-button>
              <el-button type="text" size="small" icon="el-icon-check" @click="startFun(scope.row)" v-else style="color: rgb(103, 194, 58)">
                启用
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="block" style="float: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
    <el-dialog title="新增人员" center :visible.sync="addVisible" width="500px" :close-on-click-modal="false">
      <el-form size="small" :model="addForm" ref="addForm" :rules="rules" :label-width="formLabelWidth" label-suffix="：">
        <el-form-item label="姓名" prop="NAME">
          <label slot="label">姓&nbsp;&nbsp;&nbsp;名</label>
          <el-input v-model="addForm.NAME" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="MOBILE">
          <el-input v-model="addForm.MOBILE" @change="changePhone" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="PASSWORD">
          <label slot="label">密&nbsp;&nbsp;&nbsp;码</label>
          <el-input placeholder="请输入字母数字特殊字符中至少两类的八位密码" v-model="PASSWORD" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="部门" prop="DEPARTMENT_NAME">
          <label slot="label">部&nbsp;&nbsp;&nbsp;门</label>
          <el-input v-model="addForm.DEPARTMENT_NAME" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="密码强度">
          <div class="input_span">
            <span id="one"></span>
            <span id="two"></span>
            <span id="three"></span>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close()">取 消</el-button>
        <el-button size="small" :loading="loading" @click="submitAdd('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改人员" center :visible.sync="editVisible" width="500px" :close-on-click-modal="false">
      <el-form size="small" :model="editForm" ref="editForm" style="margin-top: 0" :rules="rules" :label-width="formLabelWidth" label-suffix="：">
        <el-form-item label="名称" prop="NAME">
          <label slot="label">名&nbsp;&nbsp;&nbsp;称</label>
          <el-input v-model="editForm.NAME" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="部门" prop="DEPARTMENT_NAME">
          <label slot="label">部&nbsp;&nbsp;&nbsp;门</label>
          <el-input v-model="editForm.DEPARTMENT_NAME" style="width: 90%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editVisible = false">取 消</el-button>
        <el-button size="small" @click="submitEdit('editForm')" :loading="editLoad">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改密码" center :visible.sync="editPWDFormVisible" width="500px" :close-on-click-modal="false">
      <el-form size="small" :model="editPWDForm" ref="editPWDForm" style="margin-top: 0" :rules="rules" :label-width="formLabelWidth"
        label-suffix="：">
        <el-form-item label="密码" prop="PWD">
          <el-input placeholder="请输入字母数字特殊字符中至少两类的八位密码" v-model="editPWDForm.PWD" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="密码强度">
          <div class="input_span">
            <span id="one"></span>
            <span id="two"></span>
            <span id="three"></span>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close()">取 消</el-button>
        <el-button size="small" @click="submitEditPWD()" :loading="editLoad">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  queryPerson, stopPerson, startPerson, editPerson, addPerson, initPWD,
} from '@/assets/api/accountManage';
import crypto from '@/assets/common/cryptoJ';
import { frontEndFun } from '@/assets/api/frontFun';

export default {
  data() {
    return {
      PAGE_ID: '10046', // 页面ID 一旦规定不要轻易改动
      fun_dic: {
        1004601: 0, 1004602: 0, 1004603: 0, 1004604: 0, 1004605: 0, 1004606: 0,
      },
      editPWDForm: { PWD: '' },
      editPWDFormVisible: false,
      editLoad: false,
      rules: {
        NAME: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        MOBILE: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        DEPARTMENT_NAME: [
          { required: true, message: '请输入部门', trigger: 'blur' },
        ],
      },
      editVisible: false,
      editForm: {},
      loading: false,
      addVisible: false, // 新增模态框
      addForm: {},
      formLabelWidth: '100px',
      tableData: [{}],
      searchForm: {
        STATUS: 1,
      },
      currentPage: 1,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      totalCount: 0,
      STATUS_LIST: [
        {
          status: 0,
          name: '禁用',
        }, {
          status: 1,
          name: '启用',
        },
      ],
      statusList: ['禁用', '启用'],
      PASSWORD: '',
      warehourseList: [],
    };
  },
  watch: {
    'editPWDForm.PWD': function (newname, oldname) {
      this.msgText = this.checkStrong(newname);
      if (this.msgText > 1 || this.msgText == 1) {
        document.getElementById('one').style.background = 'red';
      } else {
        document.getElementById('one').style.background = '#eee';
      }
      if (this.msgText > 2 || this.msgText == 2) {
        document.getElementById('two').style.background = 'orange';
      } else {
        document.getElementById('two').style.background = '#eee';
      }
      if (this.msgText == 4) {
        document.getElementById('three').style.background = '#00D1B2';
      } else {
        document.getElementById('three').style.background = '#eee';
      }
    },
    PASSWORD(newname, oldname) {
      this.msgText = this.checkStrong(newname);
      if (this.msgText > 1 || this.msgText == 1) {
        document.getElementById('one').style.background = 'red';
      } else {
        document.getElementById('one').style.background = '#eee';
      }
      if (this.msgText > 2 || this.msgText == 2) {
        document.getElementById('two').style.background = 'orange';
      } else {
        document.getElementById('two').style.background = '#eee';
      }
      if (this.msgText == 4) {
        document.getElementById('three').style.background = '#00D1B2';
      } else {
        document.getElementById('three').style.background = '#eee';
      }
    },
  },
  created() {
    if (this.PERSON_MANAGE_DATA_CONDITION.CONDITION) {
      this.searchForm = this.PERSON_MANAGE_DATA_CONDITION.CONDITION;
      this.currentPage = this.PERSON_MANAGE_DATA_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryBeforeFun();
    this.queryData();
  },
  computed: {
    PERSON_MANAGE_DATA_CONDITION() {
      return this.$store.state.PERSON_MANAGE_DATA_CONDITION;
    },
  },
  methods: {
    // 手机号
    changePhone(e) {
      if (!(/^1[3456789]\d{9}$/.test(e))) {
        this.$message.show({ text: '手机号填写有误，请重新填写！', type: 'warning' });
      }
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 检测密码强弱
    checkStrong(sValue) {
      let modes = 0;
      // 正则表达式验证符合要求的
      if (sValue.length < 1) return modes;
      if (/\d/.test(sValue)) modes++; // 数字
      if (/[a-z]/.test(sValue)) modes++; // 小写
      if (/[A-Z]/.test(sValue)) modes++; // 大写
      if (/\W/.test(sValue)) modes++; // 特殊字符
      // 逻辑处理
      switch (modes) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 3:
        case 4:
          return sValue.length < 4 ? 3 : 4;
        default:
        // do nothing
      }
      return modes;
    },
    // 重置密码
    editPWD(row) {
      this.editPWDForm = { ...row };
      this.editPWDFormVisible = true;
    },
    // 重置密码
    initPWD(row) {
      this.$confirm('确定重置该账号的密码吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          ACCOUNT: row.ACCOUNT,
        };
        initPWD(params).then((result) => {
          this.$message.show({ text: '重置成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '已取消重置' });
      });
    },
    // 查看
    detail(row) {
      sessionStorage.setItem('SYSTEM_USER_ID', row.ID);
      sessionStorage.setItem('person_name', row.NAME);
      this.$router.push({ path: '/queryRole/detail' });
    },
    // 状态
    setStatus(e) {
      return this.statusList[e];
    },
    // 禁用
    stopFun(row) {
      this.$confirm('确定禁用吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SYSTEM_USER_ID: row.ID,
        };
        stopPerson(params)
          .then((result) => {
            this.$message.show({ text: '禁用成功', type: 'success' });
            this.queryData();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '已取消禁用' });
      });
    },
    // 启用
    startFun(row) {
      this.$confirm('确定启用吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SYSTEM_USER_ID: row.ID,
        };
        startPerson(params)
          .then((result) => {
            this.$message.show({ text: '启用成功', type: 'success' });
            this.queryData();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '已取消启用' });
      });
    },
    // 拉取
    queryData() {
      const params = {
        COMPANY_ID: sessionStorage.getItem('tcId'),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        STATUS: this.searchForm.STATUS,
      };
      if (this.searchForm.NAME) {
        params.NAME = this.searchForm.NAME;
      }
      if (this.searchForm.MOBILE) {
        params.MOBILE = this.searchForm.MOBILE;
      }
      if (this.searchForm.DEPARTMENT_NAME) {
        params.DEPARTMENT_NAME = this.searchForm.DEPARTMENT_NAME;
      }
      queryPerson(params)
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result[0].list;
            this.totalCount = result[0].TOTAL_COUNT;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
          this.$store.dispatch('SET_PERSON_MANAGE_DATA_CONDITION', {
            CONDITION: this.searchForm,
            DATA: this.tableData,
            TOTAL_COUNT: this.totalCount,
            CURRENT_PAGE: this.currentPage,
          });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 修改
    editPerson(row) {
      this.editVisible = true;
      this.editForm = row;
    },
    submitEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            NAME: this.editForm.NAME,
            DEPARTMENT_NAME: this.editForm.DEPARTMENT_NAME,
            SYSTEM_USER_ID: this.editForm.ID,
          };
          if (this.editForm.WAREHOUSE_ID == '') {
            params.WAREHOUSE_ID = 0;
          } else {
            params.WAREHOUSE_ID = this.editForm.WAREHOUSE_ID;
          }
          this.editLoad = true;
          editPerson(params).then((result) => {
            this.$message.show({ text: '修改成功', type: 'success' });
            this.editVisible = false;
            this.queryData();
            this.editLoad = false;
          }).catch((error) => {
            this.editLoad = false;
            this.$message.show({ text: error, type: 'error' });
          });
        } else {
          return false;
        }
      });
    },
    // 新增
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.PASSWORD.split('').length < 8) {
            this.$message.show({ text: '最少八位密码', type: 'warning' });
            return false;
          }
          if (this.checkStrong(this.PASSWORD) <= 1) {
            this.$message.show({ text: '密码太弱，请重新修改', type: 'warning' });
            return false;
          }
          if (!(/^1[3456789]\d{9}$/.test(this.addForm.MOBILE))) {
            this.$message.show({ text: '手机号填写有误，请重新填写！', type: 'warning' });
            return false;
          }
          const PWD = crypto.encrypt(this.PASSWORD, 'zAr6egnLKD9S4T2k');
          const params = {
            NAME: this.addForm.NAME,
            PASSWORD: PWD,
            MOBILE: this.addForm.MOBILE,
            DEPARTMENT_NAME: this.addForm.DEPARTMENT_NAME,
            USER_TYPE: 1,
            COMPANY_ID: sessionStorage.getItem('tcId'),
          };
          this.loading = true;
          addPerson(params).then((result) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.addForm = {};
            this.addVisible = false;
            this.loading = false;
            this.PASSWORD = '';
            this.queryData();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.loading = false;
          });
        } else {
          return false;
        }
      });
    },
    close() {
      this.addVisible = false;
      this.editPWDFormVisible = false;
      this.addForm = {};
      this.editPWDForm = {};
      this.queryData();
    },
    // 筛选
    handleSearch() {
      this.currentPage = 1;
      this.queryData();
    },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    chooseWare(e) {
      this.editForm.WAREHOUSE_ID = e;
    },
  },
};
</script>
<style scoped>
.input_span span {
  display: inline-block;
  width: 85px;
  height: 10px;
  background: #eee;
  line-height: 20px;
}

#one {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: 0px solid;
  margin-right: 3px;
}

#two {
  border-left: 0px solid;
  border-right: 0px solid;
  margin-left: -5px;
  margin-right: 3px;
}

#three {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: 0px solid;
  margin-left: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/operationCenter/accountManager.vue